// webapp/src/lib/ipsc.js
//
// IPSC handgun rules tables (2024 rulebook). Pure data + predicates, no imports.
// Twin: backend/lib/ipsc-rules.js — keep the two identical (backend/test/ipscRules.test.js
// asserts the DIVISIONS literal so they cannot drift).

export const DIVISIONS = [
    { key: 'open', label: 'Open', majorAllowed: true },
    { key: 'standard', label: 'Standard', majorAllowed: true },
    { key: 'production', label: 'Production', majorAllowed: false },
    { key: 'productionOptics', label: 'Production Optics', majorAllowed: false },
    { key: 'classic', label: 'Classic', majorAllowed: true },
    { key: 'revolver', label: 'Revolver', majorAllowed: true },
];

export const CATEGORIES = [
    { key: '', label: 'Ingen' },
    { key: 'lady', label: 'Lady' },
    { key: 'superJunior', label: 'Super Junior' },
    { key: 'junior', label: 'Junior' },
    { key: 'senior', label: 'Senior' },
    { key: 'superSenior', label: 'Super Senior' },
    { key: 'grandSenior', label: 'Grand Senior' },
];

export const POWER_FACTORS = ['minor', 'major'];

// IPSC 9.4.1.2: at most two penalties per no-shoot target.
export const NS_MAX_PER_TARGET = 2;
export const DEFAULT_HITS_PER_PAPER = 2;

const MINOR_VALUES = Object.freeze({
    A: 5, C: 3, D: 1, steel: 5, miss: -10, noShoot: -10, procedural: -10,
});
const MAJOR_VALUES = Object.freeze({
    A: 5, C: 4, D: 2, steel: 5, miss: -10, noShoot: -10, procedural: -10,
});

export function isValidDivision(key) {
    return DIVISIONS.some(d => d.key === key);
}

export function isValidCategory(key) {
    return CATEGORIES.some(c => c.key === key);
}

export function isValidPowerFactor(pf) {
    return POWER_FACTORS.includes(pf);
}

export function divisionAllowsMajor(division) {
    const found = DIVISIONS.find(d => d.key === division);
    return !!(found && found.majorAllowed);
}

// Unknown / empty PF scores as minor — never silently as major.
export function hitValues(powerFactor) {
    return { ...(powerFactor === 'major' ? MAJOR_VALUES : MINOR_VALUES) };
}
